import { render, staticRenderFns } from "./lift-report.vue?vue&type=template&id=19b4dfae&"
import script from "./lift-report.vue?vue&type=script&lang=js&"
export * from "./lift-report.vue?vue&type=script&lang=js&"
import style0 from "./lift-report.vue?vue&type=style&index=0&id=19b4dfae&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports